import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '#FFF7ED',
      200: '#FFEDD5',
      300: '#FED7AA',
      400: '#FDBA74',
      500: '#FB923C',
      600: '#F97316',
      700: '#EA580C',
      800: '#C2410C',
      900: '#9A3412',
      950: '#7C2D12',
    }
  }
});
